const colors = [
  'from-indigo-900',
  'from-emerald-900',
  'from-blue-900',
  'from-green-900',
  'from-violet-900',
  'from-yellow-900',
  'from-purple-900',
  'from-orange-900',
  'from-lime-900',
  'from-amber-900',
  'from-teal-900',
  'from-sky-900',
  'from-cyan-900',
];

export default colors;